module.exports = __webpack_public_path__ + "static/mo28-def21732ba65ce81b403c18cc01b74f3.png";